import { render, staticRenderFns } from "./ProductContentLQTafsir.vue?vue&type=template&id=1bd95bbb&scoped=true&"
import script from "./ProductContentLQTafsir.vue?vue&type=script&lang=js&"
export * from "./ProductContentLQTafsir.vue?vue&type=script&lang=js&"
import style0 from "./ProductContentLQTafsir.vue?vue&type=style&index=0&id=1bd95bbb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd95bbb",
  null
  
)

export default component.exports